var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcClockPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3 16.7L16.7 15.3L13 11.6V7H11V12.4L15.3 16.7ZM12 22C10.617 22 9.317 21.737 8.1 21.212C6.883 20.687 5.825 19.975 4.925 19.075C4.025 18.175 3.313 17.117 2.788 15.9C2.263 14.683 2 13.383 2 12C2 10.617 2.263 9.317 2.788 8.1C3.313 6.883 4.025 5.825 4.925 4.925C5.825 4.025 6.883 3.312 8.1 2.787C9.317 2.262 10.617 2 12 2C13.383 2 14.683 2.262 15.9 2.787C17.117 3.312 18.175 4.025 19.075 4.925C19.975 5.825 20.687 6.883 21.212 8.1C21.737 9.317 22 10.617 22 12C22 13.383 21.737 14.683 21.212 15.9C20.687 17.117 19.975 18.175 19.075 19.075C18.175 19.975 17.117 20.687 15.9 21.212C14.683 21.737 13.383 22 12 22ZM12 20C14.217 20 16.104 19.221 17.663 17.663C19.221 16.104 20 14.217 20 12C20 9.783 19.221 7.896 17.663 6.337C16.104 4.779 14.217 4 12 4C9.783 4 7.896 4.779 6.338 6.337C4.779 7.896 4 9.783 4 12C4 14.217 4.779 16.104 6.338 17.663C7.896 19.221 9.783 20 12 20Z",
    fill: "#00BCE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClockPrimary);
export default __webpack_public_path__ + "static/media/ic-clock-primary.2669d430c4cac15c3314299b6de3f268.svg";
export { ForwardRef as ReactComponent };